const cardUpdate = () => import('@/views/main/card/update/update.vue')
export default {
  path: '/main/card/update',
  name: 'cardUpdate',
  component: cardUpdate,
  children: []
}
